import { useEffect, useState } from 'react';

import { askInvitation } from 'common/services/linked-accounts.service';
import { LOADING_STATUS } from 'common/constants/constants';

export const usePostAskForInvitation = accountId => {
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(LOADING_STATUS.INIT);
  const [isRequested, setIsRequested] = useState(false);

  useEffect(() => {
    if (!isRequested || !accountId) return;

    const fetchData = async () => {
      try {
        await askInvitation(accountId);
      } catch (e) {
        setError(e);
      }
      setStatus(LOADING_STATUS.COMPLETED);
    };

    fetchData();
  }, [isRequested]);

  return { error, status, setIsRequested, isRequested };
};
